import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["showCharacterCount", "maxLength", "value"];
import React from "react";
var __jsx = React.createElement;
import { TextInput } from "@mantine/core";
/** SDS-sized Mantine text input with optional character count overlay. */
export function FormInput(_ref) {
  var showCharacterCount = _ref.showCharacterCount,
    maxLength = _ref.maxLength,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var currentLength = String(value !== null && value !== void 0 ? value : "").length;
  var countLabel = maxLength != null ? "".concat(currentLength, "/").concat(maxLength) : "".concat(currentLength);
  var characterCount = showCharacterCount ? /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-base-tertiary pr-1 shrink-0 pointer-events-none"
  }, countLabel) : undefined;
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    size: "sm",
    maxLength: maxLength,
    value: value,
    rightSection: characterCount,
    rightSectionWidth: showCharacterCount ? 56 : undefined
  }, props));
}